export default {
  SET_MEDICAL_FAQ(state, payload) {
    state.AllMedicalFaq = payload;
  },
  SET_SELECTED_MEDICAL_FAQ_FOR_UPDATE(state, payload) {
    state.selectedMedicalFaqForUpdate = payload;
  },
  SET_FILTERED_MEDICAL_FAQ(state, payload) {
    state.FilteredMedicalFaq = payload;
  },
};
